<template>
  <div class="main-container">
    
    <router-link to="/">
      <header >
        <img src="../assets/logo-cogedim.png" class="logo"/>
        <div class="air-du-temps"></div>
      </header>
    </router-link>
    
    <slot name="return-content"></slot>
    
    <div class="block-description">
      <slot name="left-content"></slot>
    </div>
      
    <div class="block-picture">
      <div class="mask-shadow"></div>
      <slot name="right-content"></slot>
    </div>
    
  </div>
</template>

<style lang="scss" scoped>

  ::-webkit-scrollbar {
    width: 2px;
    z-index: 2;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0);
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0);
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0); 
  }
    
  .main-container {
    
    header {
      @media (min-width: 992px) {
        /*width: 685px;*/
        width: 66.9%;
        height: 170px;
        display: block;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 4;
        background: white;
      }
      .logo { 
        z-index: 4;
        position: absolute;
        top: 30px;
        left: 30px;
      }
      .air-du-temps {
        z-index: 4;
        position: absolute;
        
        top: 42%;
        left: 70%;
        width: 195px;
        height: 40px;
        
        background-image: url("../assets/signature-white.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: left center;
        @media (min-width: 992px) {
          background-image: url("../assets/signature-purple.png");
          top: 67px;
          left: 149px;
          width: 259px;
          height: 53px;
        }
      }
    }
    
    
    .block-description {
      z-index: 3;
      background-color: white;
      text-align: left;
      overflow-y: scroll;
      width: 610px;
      padding-left: 79px;
      padding-right: 79px;
      height: 512px;
      position: fixed;
      bottom: 0;
      left: 0;
      @media (min-width: 992px) {
        position: relative;
        bottom: inherit;
        left: inherit;
        height: 100vh;
        /*width: 438px;
        padding-left: 112px;
        padding-right: 135px;*/
        width: calc(66.9% - 36.1%);
        padding-left: 16.4%;
        padding-right: 19.7%;
      }
      
      .spacer-content {
        padding-top: 60px;
        padding-bottom: 40px;
        @media (min-width: 992px) {
          padding-top: 239px;
        }
      }
      
      .title {
        font-size: 44px;
        margin-bottom: 44px;
        span{
          display: block;
        }    
      }
      
      .picto {
        margin-bottom: 17px;
      }
      
      .subtitle {
        font-size: 20px;
        line-height: 32px;
      }
      
      .text {
        font-family: 'FuturaStd-Book';
        font-size: 20px;
        line-height: 32px;
        margin-bottom: 80px;
        .list-style-custom {
          margin: 10px 0 20px 0;
          padding: 0 0 0 20px;
        }
      }
      
      .text-center {
        text-align: center;
      }
      
      .text-uppercase {
        text-transform: uppercase;
      }
      
      .text-light {
        font-family: 'FuturaStd-Book';
      }
      
      .img-fluid {
        width: 100%;
        height: auto
      }
      
      .line {
        background-color: #42145f;
        height: 1px;
        width: 60px;
        margin: 40px auto;
      }
      
      .btn-scroll {
        position: absolute;
        z-index: 3;
        position: fixed;
        bottom: 25px;
        left: calc(50% - 23px);
        @media (min-width: 992px) {
          left: 305px;
        }
      }
      
    }
    
  
  .block-picture {
    height: 512px;
    position: fixed;
    top: 0;
    width: 100%;
    @media (min-width: 992px) {
      height: inherit;
      position: inherit;
      top: inherit;
      left: inherit;
    }
    .mask-shadow {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      height: 340px;
      width: 100%;
      object-fit: contain;
      background-image: -webkit-linear-gradient(rgba(66, 20, 95, 0), #42145f);
      background-image: -moz-linear-gradient(rgba(66, 20, 95, 0), #42145f);
      background-image: -o-linear-gradient(rgba(66, 20, 95, 0), #42145f);
      background-image: linear-gradient(rgba(66, 20, 95, 0), #42145f);
    } 
    .cover-center {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      -o-object-position: center;
      object-position: center;
    }
  }
  
  .btn-return {
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 79.5px;
    background-color: #42145f;
    border-radius: 50%; 
    opacity: 0;
    margin: 34px 0 40px 0;
    position: fixed;
    z-index: 4;
    bottom: 40px;
    left: 80px;
    margin: inherit;
    @media (min-width: 992px) {
      opacity: 1;
      bottom: 85px;
      /*left: 651px;*/
      left: 63.6%;
      margin: inherit;
    }  
  } 
  
}
  
  
  
</style>
<script>
// @ is an alias to /src


export default {
  name: 'TxtPage',
  props: {
  },
  mounted ()  {
    
    document.querySelector('.block-description').addEventListener('scroll', function (e) {
      document.querySelector('.btn-scroll').style.opacity = 1 - e.target.scrollTop / 250;
    });
    
    document.querySelector('.block-description').addEventListener('scroll', function (e) {
      if(window.innerWidth < 1024) {
        document.querySelector('.btn-return').style.opacity = 0 + e.target.scrollTop / 50;
      }
    });
    
    window.addEventListener('resize', function(){
      if(window.innerWidth > 1023) {
        document.querySelector('.btn-return').style.opacity = 1;
      }
      else {
        document.querySelector('.btn-return').style.opacity = 0;
      }
    })
    
  }
}
</script>
